import { DeepPartial } from "../interfaces/deepPartial";
import { ModelState } from "../interfaces/modelState";
import dateUtil from "../lib/dateUtil";
import { get, post } from "../lib/fetchUtil";
import {
  CalculatePremiumResponse,
  CalculationModel,
  InsuredAmountsResponse,
  SaveDupStateRequest,
} from "../providers/dupFlow/DupFlow.interfaces";

export async function calculatePremium(
  calculationModel: DeepPartial<CalculationModel>
): Promise<CalculatePremiumResponse> {
  const response = await post(`dupflow/calculate`, calculationModel);

  return response.json();
}

export async function fetchInsuredAmount(effectiveDate: string): Promise<InsuredAmountsResponse> {
  const dateFormat = dateUtil.dutchDateToMoment(effectiveDate).format("YYYY-MM-DD");
  const response = await get(`dupflow/insuredamounts/${dateFormat}`);

  return response.json();
}

export async function updateDupState(data: SaveDupStateRequest): Promise<{ applicationId?: string }> {
  const response = await post(`dupflow/saveDupState`, data);
  return response.json();
}

export async function submitDupState(url: string, data: object) {
  const response = await post(url, data);
  const result = (await response.json()) as { modelState: ModelState } | undefined;
  if (response.status === 200 || response.status === 400) {
    return result;
  } else {
    throw Error("FAILED_FETCH_SUBMIT_DUP_STATE");
  }
}
